<template>
    <div class="premium-content">
        <span class="title">{{ $t("premium.prowall_title") }}</span>
        <router-link :to="{ path: $store.getters.getLocaleLink('/premium') }" class="text-decoration-none">
            <button class="upgrade-button" data="Yükselt">{{ $t("premium.prowall_button") }}</button>
        </router-link>
        <span class="description">
            {{ $t("premium.prowall_description") }}
        </span>
        <small v-if="!isAuthenticated">{{ $t("premium.prowall_warning") }}
            <router-link :to="{ path: $store.getters.getLocaleLink('/auth'), query: { authLink: 'register' } }"
                class="my-text-primary">
                {{ $t("premium.prowall_register") }}
            </router-link>
        </small>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    components: {
    },
    created() {
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated
        }
    },

}

</script>
<style scoped>
.premium-content {
    display: flex;
    flex-direction: column;
    gap: 36px;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 400px;
    width: 100%;
}

.premium-content .title {
    color: #8887C6;
    font-weight: 700;
    font-size: 36px;
    font-family: Poppins;
    cursor: context-menu;
}

.premium-content .description {
    color: #8887C6;
    font-weight: 700;
    font-size: 18px;
    font-family: Poppins;
    cursor: context-menu;
}

.upgrade-button {
    width: 144px;
    height: 48px;
    background-color: #B26C6C;
    transition: background-color 0.5s;
    cursor: pointer;
    border: none;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.upgrade-button:hover {
    background-color: #b36060;
}
</style>